import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ProblemEditorForm } from '@/features/AdminProblems/ProblemEditorForm';

export const Route = createFileRoute('/admin/problems/$problemId')({
  component: ProblemEditorPage,
});

function ProblemEditorPage() {
  const { problemId } = Route.useParams();
  const navigate = useNavigate();
  return (
    <ProblemEditorForm
      problemId={problemId}
      onBack={() => navigate({ to: '/admin/problems' })}
    />
  );
}
